@for (category of menuModel.selectableCategories(); track category; let i = $index) {
    <div class="menu-category" id="category-{{i}}" woa-responsive woa-activatable
         (onActivate)="selectCategory(category)"
         [ngClass]="{
             'featured': category.featured,
             'with-image': menuModel.showCategoryImages(),
             'with-icon': !menuModel.showCategoryImages() && configurationModel.isWaiterActor()
         }">
        @if (menuModel.showCategoryImages()) {
            <div class="menu-category-image"
                 [ngClass]="{
                     'empty': !menuModel.getCategoryImage()(category),
                     'selected': menuModel.selectedCategory() === category
                 }">
                <img class="menu-category-image-object" alt="" [woa-image-cache]="menuModel.getCategoryImage()(category)">
            </div>
        }
        <div class="menu-category-title"
             [ngClass]="{
                 'selected': menuModel.selectedCategory() === category,
                 'with-image': menuModel.showCategoryImages(),
                 'with-icon': !menuModel.showCategoryImages() && configurationModel.isWaiterActor()
             }">
            @if (!menuModel.showCategoryImages() && configurationModel.isWaiterActor()) {
                <div class="menu-category-title-icon" woa-touchable>
                    {{menuModel.getCategoryIconText()(category)}}
                </div>
            }
            <div class="menu-category-title-name"
                 [ngClass]="{
                     'selected': menuModel.selectedCategory() === category
                 }">
                {{menuModel.getCategoryDisplayName()(category)}}
            </div>
            @if (!menuModel.showCategoryImages() && showNavIcons()) {
                <woa-icon-button class="menu-category-title-button" [type]="IconButtonType.FORWARD"
                (onActivate)="selectCategory(category)"></woa-icon-button>
            }
        </div>
    </div>
}
